<template>
    <div class="card mt-3 ">
        <div class="card-body py-2 ">
            <div class="card-title pt-2">نمودار بازدید 30 روز گذشته</div>
            <view-chart :chartData="chartData"></view-chart>
        </div>
    </div>

</template>

<script>

    import Vue from 'vue'
    import VueCharts from 'vue-chartjs'
    import {Bar} from 'vue-chartjs'

    Vue.component('view-chart', {
        extends: Bar,
        props: ['chartData'],
        watch: {
            chartData: function () {
                this.renderChart(this.chartData, {
                    legend: {display: false},
                    responsive: true, // my new default options
                    maintainAspectRatio: false, // my new default options

                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                callback: function (value) {
                                    if (value % 1 === 0) {
                                        return value;
                                    }
                                }
                            }
                        }],
                        xAxes: [{
                            barPercentage: 0.9,
                            categoryPercentage: 1,
                            display: true,
                            ticks: {
                                autoSkip: false
                            }
                        }]
                    }
                })
            }
        }
    })

    export default {
        name: "viewchart",
        computed: {
            chartData: function () {
                return {
                    labels: this.datasetsLables,
                    datasets: [{
                        backgroundColor: '#007bff',
                        data: this.datasetsData
                    }]
                }
            }
        },
        data: function () {
            return {

                datasetsLables: [],
                datasetsData: []
            }
        },
        mounted: function () {
            let this2 = this;
            this.axios.get('fa/v1/dashboard/views').then(function ({data}) {

                this2.datasetsLables = [];
                this2.datasetsData = [];
                data.data.bars.forEach(function (v, i) {
                    this2.datasetsLables.push(this2.$moment(v.label).format( "jYYYY/jMM/jDD"))
                     this2.datasetsData.push(v.total)

                });
            });
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/charts/Viewchart.vue